<template>
  <l-steps
    :expand="true"
    type="secondary"
    :steps="steps"
    :current-step-index="currentStepIndex"
  />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { LSteps } from '@last/core-ui/paprika'

import { useStepsStore } from '@/store/steps'

const stepsStore = useStepsStore()
const { steps, currentStepIndex } = storeToRefs(stepsStore)
</script>
